export const clientDisplayName = c => ((c?.company || '').trim()) || c?.name || '';
